module.exports = __webpack_public_path__ + "img/UNIDAD_W.83fe9836.svg";